import { replaceBracedComponents } from "./replaceBracedComponents";
export const replaceBracedComponentsInBaseUrl = (config) => {
    const transformedConfig = { ...config };
    if (config.baseUrl)
        transformedConfig.baseUrl = replaceBracedComponents(config.baseUrl, config);
    return transformedConfig;
};
